import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public title = 'walk-and-win Manager';

  constructor(
    private router: Router,
    private translate: TranslateService
  ) {
    // let language = localStorage.getItem('locale') || 'fr';
    let language =  'fr';

    this.translate.setDefaultLang(language!);
    this.translate.use(language!);

  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

}
